import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { ReportProvider } from "./context/ReportContext";
import LoginPage from "./components/LoginPage";
import PowerBIEmbed from "./components/PowerBIEmbed";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./components/HomePage";
import PageLayout from "./components/PageLayout";
import defaultReport from "./config/defaultReport";

function App() {
  const defaultPath = `/${encodeURIComponent(defaultReport.dashboard)}/${encodeURIComponent(defaultReport.report)}/${encodeURIComponent(defaultReport.page)}`;

  return (
    <ReportProvider>
      <Router>
        <Routes>
          {/* Public login route */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected homepage auto-redirects to default report */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />

          {/* Legacy redirect path to default */}
          <Route
            path="/advance-metering"
            element={<Navigate to={defaultPath} replace />}
          />

          {/* Embedded report route */}
          <Route
            path="/:dashboard/:report/:page"
            element={
              <ProtectedRoute>
                <PageLayout>
                  <PowerBIEmbed />
                </PageLayout>
              </ProtectedRoute>
            }
          />

          {/* Fallback to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ReportProvider>
  );
}

export default App;
